import React, { useState, useEffect } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import { NAV_ITEMS, VIRTUAL_BRANDS } from "../mock/data";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [brandsOpen, setBrandsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#07070A]/90 backdrop-blur-xl border-b border-white/8" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-10 h-[80px] flex items-center justify-between">
        <a href="/" className="flex items-center gap-2 shrink-0 group">
          <span className="font-display text-white text-2xl leading-none flex items-baseline">
            <span className="text-[#14E0BF] mr-0.5">k</span>itchn<span className="text-[#14E0BF]">worx</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_ITEMS.map((item) => (
            <div
              key={item.label}
              className="relative"
              onMouseEnter={() => item.hasDropdown && setBrandsOpen(true)}
              onMouseLeave={() => item.hasDropdown && setBrandsOpen(false)}
            >
              <a
                href={item.href}
                className="nav-link text-[14px] font-semibold text-white flex items-center gap-1"
              >
                {item.label}
                {item.hasDropdown && <ChevronDown className="w-3.5 h-3.5" />}
              </a>
              {item.hasDropdown && brandsOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-4 animate-scale-in">
                  <div className="bg-[#14141B] rounded-2xl shadow-2xl border border-white/10 min-w-[280px] py-3 teal-glow">
                    {VIRTUAL_BRANDS.map((b) => (
                      <a
                        key={b.id}
                        href={`#brand-${b.id}`}
                        className="flex items-center justify-between px-5 py-3 text-sm font-semibold text-white hover:bg-white/5 transition-colors group"
                      >
                        <span>{b.name}</span>
                        <span
                          className="text-xs font-mono opacity-0 group-hover:opacity-100 transition-opacity"
                          style={{ color: b.accent }}
                        >
                          {b.cuisine}
                        </span>
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>

        <a
          href="#journey"
          className="hidden lg:inline-flex btn-pill items-center gap-2 bg-[#14E0BF] hover:bg-[#0FB89C] text-[#07070A] font-display text-[12px] tracking-wider uppercase px-5 py-3 rounded-full"
        >
          Apply Now
          <span className="w-1.5 h-1.5 rounded-full bg-[#07070A] animate-pulse-dot" />
        </a>

        <button
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-full bg-[#14E0BF] text-[#07070A]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#07070A]">
          <nav className="px-6 py-4 flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="py-3 text-base font-semibold text-white border-b border-white/5"
                onClick={() => setOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#journey"
              className="mt-4 bg-[#14E0BF] text-[#07070A] font-display uppercase tracking-wide text-sm text-center px-6 py-3.5 rounded-full"
              onClick={() => setOpen(false)}
            >
              Apply Now
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
